import {setSelectedTipChannel} from 'stores/actions/protocolEditorAction';
import {getIsAspirateDispenseModalShown} from 'stores/selectors/virtualTraySelectors';
import {AspirateDispenseVolumeModalBusiness} from './aspirateDispenseVolumeModalBusiness';

export const resetTipChannel = () => (dispatch) => dispatch(setSelectedTipChannel(''));

export const checkVolumeModalAndApplyIfOpened = () => (dispatch, getState) => {
  const isAspirateDispenseVolumeModalShown = getIsAspirateDispenseModalShown(getState());

  if (isAspirateDispenseVolumeModalShown) {
    dispatch(AspirateDispenseVolumeModalBusiness.apply());
  }
};
